import React from 'react';
import clsx from 'clsx';

export type UIKitIconVariant = 'filled' | 'outlined';
type UIKitIconSize = 'xs' | 's' | 'm' | 'l' | 'xl';

const FONT_SIZE_BY_SIZE: Record<UIKitIconSize, string> = {
  xs: '12px',
  s: '16px',
  m: '24px',
  l: '32px',
  xl: '16px',
};

interface UIKitIconProps {
  /** Nombre del ícono según Material Icons (por ej. "download", "upload_file", "description") */
  name: string;
  /** Variante visual: filled u outlined (por defecto outlined, que suele ser el estándar de UI Kits modernos) */
  variant?: UIKitIconVariant;
  /** Tamaño en px aproximados */
  size?: UIKitIconSize;
  className?: string;
  style?: React.CSSProperties;
}

const UIKitIcon: React.FC<UIKitIconProps> = ({
  name,
  variant = 'outlined',
  size = 'm',
  className,
  style,
}) => {
  const baseClass = variant === 'outlined' ? 'material-icons-outlined' : 'material-icons';

  const fontSize = FONT_SIZE_BY_SIZE[size];

  return (
    <span className={clsx(baseClass, className)} style={{ ...style, fontSize }}>
      {name}
    </span>
  );
};

export default UIKitIcon;
